module.exports = __webpack_public_path__ + "media/images/bg_customer_mv_pc-7b360fee8db0348871f4ae89ca86449b.jpg";